import { IgenomicsAction } from '@ispm/core/interfaces/genomics-action.interface';
import { IImmunotherapyFinding } from '../components/immunotherapy/interfaces/immunotherapy-finding.interface';
import { FINDINGS_ACTIONS } from '../constants/findings.constants';
import { WorkflowDrivenCacheablesEntity } from '@ispm/workflow/entities/workflow-driven-cacheables.entity';
import { CORE_ACTIONS } from '@ispm/core/constants/core-actions.constant';


export interface IFindingsState {
  molecularFinding: IImmunotherapyFinding;
}

const InitFindingState: IFindingsState = {
  molecularFinding: null
};

export function FindingsReducer(state: IFindingsState = InitFindingState, action: IgenomicsAction<WorkflowDrivenCacheablesEntity>): IFindingsState {
  switch (action.type) {
    case CORE_ACTIONS.CLEAR_ALL_CACHED_ITEMS:
    case FINDINGS_ACTIONS.INIT:
      return { ...InitFindingState};
    case FINDINGS_ACTIONS.UPDATE:
      state[action.payload.getValue().key] = action.payload.upsert(state[action.payload.getValue().key], null, action.payload.getValue().value);
      return { ...state};
    default:
      return state;
  }
}
